import { BACKEND_URL } from "@/lib/backend";
import { createContext, useContext, useState, useEffect, useCallback } from "react";

const API = `${BACKEND_URL}/api`;

function getCookie(name) {
  const m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  return m ? decodeURIComponent(m[1]) : "";
}

export async function customerApi(path, { method = "GET", body } = {}) {
  const headers = { "Content-Type": "application/json" };
  if (method !== "GET") headers["X-CSRF-Token"] = getCookie("rst_customer_csrf");
  const res = await fetch(`${API}${path}`, {
    method, headers, credentials: "include", body: body ? JSON.stringify(body) : undefined,
  });
  let data = {}; try { data = await res.json(); } catch (e) {}
  return { ok: res.ok, status: res.status, data };
}

const CustomerContext = createContext(null);

export function CustomerProvider({ children }) {
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const r = await customerApi("/customer/auth/me");
    setCustomer(r.ok ? r.data : null);
    setLoading(false);
    return r.ok ? r.data : null;
  }, []);
  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const r = await customerApi("/customer/auth/login", { method: "POST", body: { email, password } });
    if (r.ok) await refresh();
    return r;
  };
  const register = async (email, password, business) =>
    customerApi("/customer/auth/register", { method: "POST", body: { email, password, ...(business || {}) } });
  const logout = async () => {
    await customerApi("/customer/auth/logout", { method: "POST" });
    setCustomer(null);
  };

  return (
    <CustomerContext.Provider value={{ customer, loading, refresh, login, register, logout }}>
      {children}
    </CustomerContext.Provider>
  );
}

export function useCustomer() {
  const ctx = useContext(CustomerContext);
  if (!ctx) throw new Error("useCustomer must be used within CustomerProvider");
  return ctx;
}

export const useOptionalCustomer = () => useContext(CustomerContext);  // T58: shared components also rendered in admin previews
